import {
  LogLevels,
  createLogger as _createLogger
} from "@backmarket/front-logger";
import { getDefaultAttributes } from "./getDefaultAttributes.js";
import { getTransports } from "./getTransports.js";
export function createLogger(options) {
  const attributes = {
    ...getDefaultAttributes(),
    ...options.attributes
  };
  return _createLogger({
    level: LogLevels.INFO,
    transports: getTransports(),
    attributes
  });
}
